import { apiRequestWithChecks } from "./api";

export const inAppNotificationApi = {
    getList(token) {
        return apiRequestWithChecks("GET", "/api/in-app-notification/list", {
            Authorization: "Bearer " + token
        });
    },

    getUnreadCount(token) {
        return apiRequestWithChecks("GET", "/api/in-app-notification/unread-count", {
            Authorization: "Bearer " + token
        });
    },

    markRead(token, id) {
        return apiRequestWithChecks("PUT", `/api/in-app-notification/${id}/read`, {
            Authorization: "Bearer " + token
        });
    },

    markAllRead(token) {
        return apiRequestWithChecks("PUT", "/api/in-app-notification/read-all", {
            Authorization: "Bearer " + token
        });
    }
};
